import React, { useState, useRef } from 'react';

const ImageCompare = ({ beforeImage, afterImage, alt }) => {
  const [sliderPosition, setSliderPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef(null);

  const handleMove = (event) => {
    if (!isDragging) return;

    const bounds = containerRef.current.getBoundingClientRect();
    let x = (event.clientX || event.touches?.[0].clientX) - bounds.left;
    let position = (x / bounds.width) * 100;

    position = Math.max(0, Math.min(100, position));
    setSliderPosition(position);
  };

  const handleMouseDown = () => {
    setIsDragging(true);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleTouchStart = () => {
    setIsDragging(true);
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  React.useEffect(() => {
    document.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('touchend', handleTouchEnd);

    return () => {
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className="relative w-full h-full overflow-hidden rounded-lg select-none"
      onMouseMove={handleMove}
      onTouchMove={handleMove}
      onMouseLeave={() => setIsDragging(false)}
    >
      {/* Base (Before) Image */}
      <img
        src={beforeImage}
        alt={`${alt} - Before`}
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Overlay (After) Image with Clip Path */}
      <img
        src={afterImage}
        alt={`${alt} - After`}
        className="absolute inset-0 w-full h-full object-cover"
        style={{
          clipPath: `inset(0 ${100 - sliderPosition}% 0 0)`,
          zIndex: 1
        }}
      />

      {/* Slider Button */}
      <div
        className="absolute top-0 bottom-0 z-10 w-1 bg-white cursor-ew-resize"
        style={{ left: `${sliderPosition}%` }}
        onMouseDown={handleMouseDown}
        onTouchStart={handleTouchStart}
      >
        <div
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center cursor-ew-resize"
          onMouseDown={handleMouseDown}
          onTouchStart={handleTouchStart}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-gray-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 19l7-7-7-7"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default ImageCompare;
